import expenseResources from "@/shared/resource/expense";
import { authorizedAxios } from "@/shared/api/authorizedAxios";
import { HsabPayee } from "@/shared/types";

export function getPayees () {
    return authorizedAxios.get<HsabPayee>(expenseResources.getPayeesForUser());
}

export function createPayee (item) {
    return authorizedAxios.post<HsabPayee>(expenseResources.createPayee(), item);
}

export function updatePayee (item) {
    return authorizedAxios.put<HsabPayee>(expenseResources.updatePayee(), item);
}

export function deletePayee (payeeId: number) {
    return authorizedAxios.put<HsabPayee>(expenseResources.deletePayee(payeeId));
}
